import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-maritime-claims',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './maritime-claims.component.html',
  styleUrl: './maritime-claims.component.scss'
})
export class MaritimeClaimsComponent {

}
